export default "__VITE_ASSET__2ba8b846__"